import { v4 as uuidv4 } from 'uuid';
import { findIndex } from 'lodash';

export default () => ({
    notifications: [],

    add(notification) {
        const id = uuidv4();
        const level = notification.level === 'danger' ? 'error' : (notification.level ?? 'success');

        this.notifications.push({
            id: id,
            visible: false,
            level: ['info', 'success', 'warning', 'error'].includes(level) ? level : 'info',
            title: notification.title ?? 'Success!',
            message: notification.message ?? 'The action completed.'
        });

        setTimeout(() => this.show(id), 50);
        setTimeout(() => this.hide(id), (notification.duration ?? 3000) + 50);
    },

    show(id) {
        const index = findIndex(this.notifications, { id });
        if (index === -1) return;
        this.notifications[index].visible = true;
    },

    hide(id) {
        const index = findIndex(this.notifications, { id });
        if (index === -1) return;
        this.notifications[index].visible = false;
    }
});
